import { render, staticRenderFns } from "./CotizaHub.vue?vue&type=template&id=7b6487ef"
import script from "./CotizaHub.vue?vue&type=script&lang=js"
export * from "./CotizaHub.vue?vue&type=script&lang=js"
import style0 from "./CotizaHub.vue?vue&type=style&index=0&id=7b6487ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VApp,VCarousel,VCarouselItem,VCol,VContainer,VContent,VRow,VSheet})
